import ProductFilters from './productFilters'

export default ProductFilters
